import { SortableColumn as SortableColumnBase } from 'prime-ng-old/table';
import { PARENT_TABLE } from '../table.injection-token';
import * as i0 from "@angular/core";
// required because of the constructor needing reference to ui-table component
export let SortableColumn = /*#__PURE__*/(() => {
  class SortableColumn extends SortableColumnBase {
    // @Input("pSortableColumn") field: string;
    // @Input() pSortableColumnDisabled: boolean;
    constructor(dt) {
      super(dt);
      this.dt = dt;
    }
    static {
      this.ɵfac = function SortableColumn_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SortableColumn)(i0.ɵɵdirectiveInject(PARENT_TABLE));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: SortableColumn,
        selectors: [["", "pSortableColumn", ""]],
        hostAttrs: [1, "p-element"],
        hostVars: 7,
        hostBindings: function SortableColumn_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.isEnabled() ? "0" : null)("role", "columnheader")("aria-sort", ctx.sortOrder);
            i0.ɵɵclassProp("p-sortable-column", ctx.isEnabled())("p-highlight", ctx.sorted);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return SortableColumn;
})();